import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  children?: React.ReactNode;
  className?: string;
  variant?: 'terra' | 'white';
  href?: string;
  showIcon?: boolean;
}
const VARIANTS: Record<string, string> = {
  terra: 'bg-brand-terra text-white hover:bg-brand-terradark focus-visible:ring-brand-terra',
  white: 'bg-white text-brand-terra hover:bg-brand-cream focus-visible:ring-white'
};
export function CTAButton({
  children = 'Quiero el Pack Arte Lista',
  className = '',
  variant = 'terra',
  href = '#oferta',
  showIcon = true
}: CTAButtonProps) {
  return <a href={href} className={`inline-flex w-full items-center justify-center gap-2.5 rounded-full px-9 py-4 text-xs font-semibold uppercase tracking-[0.14em] shadow-[0_8px_24px_rgba(232,69,69,0.18)] transition-[transform,box-shadow] duration-200 ease-out hover:-translate-y-0.5 hover:shadow-[0_12px_30px_rgba(232,69,69,0.26)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-brand-cream sm:w-auto sm:text-sm ${VARIANTS[variant]} ${className}`} data-id="element-43" data-mp="33pfkzpq99pf0">
      {children}
      {showIcon && <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-44" data-mp="1dcb9mpjlr8u6" />}
    </a>;
}